<template>
  <div class="pb50 custom-tree-container">
    <div class="p20">
      <el-form size="small" :inline="true" :model="params" class="demo-form-inline">
        <el-form-item label="昵称或手机">
          <el-input v-model="params.keyword" placeholder="请输入昵称或手机"></el-input>
        </el-form-item>
        <el-form-item label="用户ID">
          <el-input v-model="params.user_id" placeholder="请输入用户ID"></el-input>
        </el-form-item>
        <el-form-item label="地址(省/市)" prop="region_id">
          <el-select v-model="params.province_id" placeholder="省" @change="initCity" clearable>
            <el-option :label="item.name" :value="item.id" v-for="(item,index) in areaList" :key='index'></el-option>
          </el-select>
          <el-select v-if="params.province_id!=''" v-model="params.city_id" placeholder="市" @change="initRegion" clearable>
            <el-option :label="item1.name" :value="item1.id" v-for="(item1,index1) in areaList[params.province_id]['city']"
              :key='index1'></el-option>
          </el-select>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" icon="el-icon-search" @click="handelSearch">查询</el-button>
        </el-form-item>
      </el-form>
    <!-- <el-input placeholder="请输入内容" v-model="params.keyword" type="text" style="width:500px">
      <template slot="prepend">搜索</template>
      <el-button slot="append" icon="el-icon-search" @click="handelSearch"></el-button>
    </el-input> -->
    
      <el-tag class="mr10" v-for="(v, i) in grade" :key="i" :type="gradeIndex==i? '' : 'info'" @click="handelType(i)">{{ v.name }}</el-tag>
    </div>
    <span class="p10 ml20 blue fb">共：{{treeData.length}} 人</span>
    <el-input
      size="small"
      class="mb20 ml30"
      style="width:350px"
      placeholder="输入关键字"
      v-model="filterText">
      <template slot="prepend">关键字过滤</template>
    </el-input>
    <el-tree
      v-loading="loading"
      element-loading-text="拼命加载中"
      element-loading-background="rgba(255, 255, 255, 0.8)"
      empty-text=""
      :data="treeData"
      node-key="id"
      default-expand-all
      @node-drop="handleDrop"
      @node-click="handleClick"
      draggable
      :expand-on-click-node="false"
      :filter-node-method="filterNode"
      ref="tree"
    >
      <span class="custom-tree-node" slot-scope="{ node, data }">
        <span class="m30">{{ data.id }}. <span class="gray9">{{ data.addressDefault ? ('['+data.addressDefault.region.province+'-'+data.addressDefault.region.city+']') : '' }}</span> {{ data.nick_name }} {{ data.mobile }} <el-tag type="info" class="style1-tag">{{ data.grade_name }}</el-tag> 
        <i class="el-icon-user" v-if="data.count"><span class="gray9">直推：</span>{{ data.count }}人,其中：</i> 
        <template v-for="(item,key) in data.refree_list">
          <span><el-tag type="info" class="style1-tag">{{ item.grade.name }}</el-tag>{{ item.count }}人 </span>
        </template>
        <!-- <span :data="data.refree_list">
           <span><el-tag type="info" class="style1-tag">{{ scope.row.grade.name }}</el-tag>{{ scope.count }}人 </span>
        </span> -->
       
        <i class="el-icon-copy-document" @click="copytext(data.id + ' ' +data.nick_name+ ' ' +data.mobile)" title="复制"></i>
        </span>
        <!-- <span>
          <el-button
            type="text"
            size="mini"
            @click="() => append(data)">
            Append
          </el-button>
          <el-button
            type="text"
            size="mini"
            @click="() => remove(node, data)">
            Delete
          </el-button>
        </span> -->
      </span>
    </el-tree>
    <div class="pagination">
        <el-pagination
          @current-change="handleCurrentChange"
          background
          :current-page="curPage"
          :page-size="pageSize"
          layout="total, prev, pager, next"
          :total="totalDataNumber"
        ></el-pagination>
      </div>
  </div>
</template>
<script>
import UserApi from "@/api/user.js";
import {copytext} from "@/utils/base.js";

export default {
  data() {
    return {
      /*一页多少条*/
      pageSize: 20,
      /*一共多少条数据*/
      totalDataNumber: 0,
      /*当前是第几页*/
      curPage: 1,
      /*省市区*/
      areaList: [],
      loading: false,
      fullscreenLoading: {},
      treeData: [],
      appendData: [],
      grade: [],
      gradeIndex: 0,
      defaultProps: {
        children: "children",
        label: "label",
      },
      params: {
        grade_id: 0,
        referee_id: 0,
        user_id: '',
        keyword: '',
        province_id: '',
        city_id: '',
      },
      filterText: ''
    };
  },
  watch: {
    filterText(val) {
      this.$refs.tree.filter(val);
    }
  },
  created() {
    const params = this.$route.query;
    Object.assign(this.params, params);
    console.log(this.params);

    /*获取数据*/
    this.getData();
    this.getGradeList();    
  },
  methods: {
    /*初始化城市id*/
    initCity() {
      this.params.city_id = ''
    },

    /*初始化区id*/
    initRegion() {
      this.params.region_id = ''
    },
    /*搜索*/
    handelSearch(){
      this.params.referee_id = 0;
      this.gradeIndex = 0;
      this.treeData = [];
      this.getData();
    },
    getGradeList(){
      let self = this;
      UserApi.structureGrade()
      .then((data) => {
        self.grade = data.data.grade;
        self.grade.unshift({grade_id: 0, name: '全部'});
        self.areaList = data.data.regionData;
      })
      .catch((error) => {});
    },
    
    /*选择第几页*/
    handleCurrentChange(val) {
      let self = this;
      self.curPage = val;
      self.loading = true;
      self.getData();
    },
    /*获取数据*/
    getData(node) {
      let self = this;
      self.loading = true;
      let params = self.params;
      params.page = self.curPage;
      params.list_rows = self.pageSize;
      params.limit = self.pageSize;
      UserApi.structureList(params, true)
        .then((data) => {
          if (self.params.referee_id){
            self.append(node, data.data.list);
          }else{
            self.treeData = data.data.list.data;
            self.totalDataNumber = data.data.list.total;
            
          }
          self.loading = false;
        })
        .catch((error) => {});
    },

    filterNode(value, data) {
      if (!value) return true;
      return data.label.indexOf(value) !== -1;
    },

    // 筛选分类
    handelType(i){
      this.gradeIndex = i;
      this.treeData = [];
      this.params.referee_id = 0;
      this.params.user_id = '';
      this.params.grade_id = this.grade[i].grade_id;
      this.curPage = 1;
      this.getData();
    },

    // 点击
    handleClick(e){
      this.params.referee_id = e.id;
      this.params.grade_id = 0;
      if (!e.children && e.end==0){
        this.getData(e);
      }
      // 复制
      // copytext(this, e.id + ' ' +e.nick_name+ ' ' +e.mobile);

      // 调父方法
      // this.$emit('addTab', e);
    },

    // 增加
    append(data, children_data) {
      if (!children_data.length) data.end = 1;
      children_data.forEach(e => {
        if (!data.children) {
          this.$set(data, "children", []);
        }
        data.children.push(e);
      });
    },

    remove(node, data) {
      const parent = node.parent;
      const children = parent.data.children || parent.data;
      const index = children.findIndex((d) => d.id === data.id);
      children.splice(index, 1);
    },
    renderContent(h, { node, data, store }) {
      return (
        <span class="custom-tree-node">
          <span>{node.label}</span>
          <span>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.append(data)}
            >
              Append
            </el-button>
            <el-button
              size="mini"
              type="text"
              on-click={() => this.remove(node, data)}
            >
              Delete
            </el-button>
          </span>
        </span>
      );
    },
    handleDrop(draggingNode, dropNode, dropType, ev) {
      console.log("tree drop: ", dropNode.label);
    },
    copytext(text){
      copytext(this, text);
    }
  },
};
</script>

<style>
.custom-tree-node {
  flex: 1;
  display: flex;
  align-items: center;
  justify-content: space-between;
  font-size: 14px;
  padding-right: 8px;
}
.el-tree-node__content{
  height: 30px;
}
</style>



// WEBPACK FOOTER //
// src/views/user/structure/part/Tree.vue